import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { WhatsAppButton, MobileBottomNav } from "./Floating";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <WhatsAppButton />
      <MobileBottomNav />
      <div className="h-16 lg:hidden" />
    </div>
  );
}
